import { Component, OnInit, ViewChild, inject } from "@angular/core";
import { MatSelect } from "@angular/material/select";
import { PlanningSegmentStore } from "@app/services/store/planning-segment-store";
import { Store } from "@ngrx/store";
import { BaseTimeNavigablePageComponent } from "@app/view/shared/base-pages/base-time-navigable-page/base-time-navigable-page.component";
import { MatDialog } from "@angular/material/dialog";
import { BulkAvailabilityWizardComponent } from "@app/view/diary/bulk-availability-wizard/bulk-availability-wizard.component";
import { MatToolbar, MatToolbarRow } from "@angular/material/toolbar";
import { DateNavigatorComponent } from "../../shared/date-navigator/date-navigator.component";
import { MatInput } from "@angular/material/input";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { MatOption } from "@angular/material/core";
import { MatCheckbox } from "@angular/material/checkbox";
import { MatAnchor, MatIconButton } from "@angular/material/button";
import { MatIcon } from "@angular/material/icon";
import { RouterLink } from "@angular/router";
import { MatCard } from "@angular/material/card";
import { DiaryViewerComponent } from "../diary-viewer/diary-viewer.component";
import { MomentModule } from "ngx-moment";
import { MatTooltipModule } from "@angular/material/tooltip";

@Component({
  selector: "app-diary-day-view",
  templateUrl: "./diary-day-view.component.html",
  styleUrls: ["./diary-day-view.component.scss"],
  imports: [
    MatToolbar,
    MatToolbarRow,
    DateNavigatorComponent,
    MatInput,
    MatSelect,
    FormsModule,
    ReactiveFormsModule,
    MatOption,
    MatCheckbox,
    MatIconButton,
    MatIcon,
    MatAnchor,
    RouterLink,
    MatCard,
    MatTooltipModule,
    DiaryViewerComponent,
    MomentModule
  ]
})
export class DiaryDayViewComponent
  extends BaseTimeNavigablePageComponent
  implements OnInit
{
  dialog = inject(MatDialog);

  @ViewChild("timeFrom", { static: false }) timeFrom: any;
  @ViewChild("timeFromSelect", { static: false }) timeFromSelect: MatSelect;
  @ViewChild("timeTo", { static: false }) timeTo: any;
  @ViewChild("timeToSelect", { static: false }) timeToSelect: MatSelect;

  constructor() {
    super();

    setInterval(() => {
      this.time = Date.now();
    }, 1000);
  }

  columnsChanged() {
    this.saveLayout();
  }

  activeOnlyChanged(checked: boolean) {
    if (this.scheduleViewer instanceof DiaryViewerComponent) {
      this.scheduleViewer.setActiveOnly(checked);
      this.saveLayout();
    }
  }

  openBulkWizard() {
    console.log("opening bulk wizard");
    this.dialog.open(BulkAvailabilityWizardComponent, { disableClose: true });
  }
}
